import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ButtonComponent } from '../../buttons/button/button.component';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonType } from '../../enum/button-type.enum';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-confirmation-dialog',
  imports: [ButtonComponent, DialogHeaderComponent, ReactiveFormsModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  private dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);

  public config = signal<ConfirmationDialogConfig | null>(null);

  protected readonly ButtonType = ButtonType;

  primaryButtonClicked() {
    this.dialogRef.close(true);
  }

  secondaryButtonClicked() {
    this.dialogRef.close(false);
  }

  closeClicked() {
    this.dialogRef.close(undefined);
  }
}

export interface ConfirmationDialogConfig {
  title: string;
  message: string;
  extraMessages?: string[];
  primaryButtonText: string;
  secondaryButtonText: string;
}
